module.exports = __webpack_public_path__ + "static/media/SK.af046a19.svg";